import script from "./programChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./programChart.vue?vue&type=script&lang=ts&setup=true"

import "./programChart.vue?vue&type=style&index=0&id=d6dcab32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6dcab32"]])

export default __exports__